import { OrganizationKeyName } from "../../../model/Organization";

export const GET_SHOP = "SHOP:GET_SHOP";

export const getShopAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_SHOP as typeof GET_SHOP,
  id,
  organization,
});

export type GetShopAction = ReturnType<typeof getShopAction>;
